module.exports = __webpack_public_path__ + "static/forecast/fresh-snow/no_snow-9a8b1fddad89df883f9df41a80ebc8cd.svg";